// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1830ee08","963":"49a3f6bc"}[chunkId] + ".chunk.js";
};